import { gql, useSubscription } from '@apollo/client'

export const PAYMENT_TRANSACTION_STATUS_SUBSCRIPTION = gql`
  subscription PaymentTransactionStatus($transactionId: ID!) {
    paymentTransactionStatus(transactionId: $transactionId) {
      __typename
      id
      state {
        id
        name
      }
      creationDate
      modificationDate
      amount
    }
  }
`

export const usePaymentTransactionStatusSubscription = (
  transactionId: string,
) =>
  useSubscription(PAYMENT_TRANSACTION_STATUS_SUBSCRIPTION, {
    variables: { transactionId },
    skip: !transactionId,
  })
